import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import { ROUTES } from 'constants/routes';
import { actionCreators as authActions } from 'redux/authHandlers';
import { gaTrackPageView } from 'services/AnalyticsService';
import { message } from 'utils/stringUtils';

import Configuration from './layout';

class ConfigurationContainer extends Component {
  componentDidMount() {
    gaTrackPageView(ROUTES.CONFIGURATION);
  }

  handleChangePassword = values => {
    this.props.dispatch(
      authActions.changePassword(values.currentPassword, values.newPassword, values.confirmNewPassword)
    );
  };

  handleGoToChangeUserInfo = () => this.props.dispatch(push(ROUTES.CHANGE_USER_INFO));

  handleGoToDashboard = () => this.props.dispatch(push(ROUTES.ACCOUNT_STATUS));

  render() {
    return (
      <Configuration
        {...this.props}
        onChangePassword={this.handleChangePassword}
        onGoToChangeUserInfo={this.handleGoToChangeUserInfo}
        onGoToDashboard={this.handleGoToDashboard}
      />
    );
  }
}

const retrieveName = (firstName, lastName) =>
  firstName || lastName ? `${firstName} ${lastName}` : message('ChangeUserInfo:withoutData');

const mapStateToProps = store => ({
  userName:
    store.auth.currentUser &&
    retrieveName(store.auth.currentUser.first_name, store.auth.currentUser.last_name),
  user: store.auth.currentUser,
  email: store.auth.currentUser.email
});

export default connect(mapStateToProps)(ConfigurationContainer);
